import React from "react";
import CustomLogoFooter from "../../assets/CustomLogo/CustomLogoFooter";

type Props = {};

export default function Footer({}: Props) {
  return (
    <footer className="footer">
      <div className="footer_warpper">
        <div className="footer_row">
          <div className="footer_top">
            <div className="item">
              <article className="article">
                <div className="title">
                  <h6>Categories</h6>
                </div>
                <div className="content">
                  <ul>
                    <li>
                      <a href="#">Graphics &amp; Design</a>
                    </li>
                    <li>
                      <a href="#">Digital Marketing</a>
                    </li>
                    <li>
                      <a href="#">Writing &amp; Translation</a>
                    </li>
                    <li>
                      <a href="#">Video &amp; Animation</a>
                    </li>
                    <li>
                      <a href="#">Music &amp; Audio</a>
                    </li>
                    <li>
                      <a href="#">Programming &amp; Tech</a>
                    </li>
                    <li>
                      <a href="#">Data</a>
                    </li>
                    <li>
                      <a href="#">Business</a>
                    </li>
                    <li>
                      <a href="#">Lifestyle</a>
                    </li>
                    <li>
                      <a href="#">Sitemap</a>
                    </li>
                  </ul>
                </div>
              </article>
            </div>
            <div className="item">
              <article className="article">
                <div className="title">
                  <h6>About</h6>
                </div>
                <div className="content">
                  <ul>
                    <li>
                      <a href="#" rel="">
                        Careers
                      </a>
                    </li>
                    <li>
                      <a href="#" rel="">
                        Press &amp; News
                      </a>
                    </li>
                    <li>
                      <a href="#" rel="">
                        Partnerships
                      </a>
                    </li>
                    <li>
                      <a href="#" rel="">
                        Privacy Policy
                      </a>
                    </li>
                    <li>
                      <a href="#" rel="">
                        Terms of Service
                      </a>
                    </li>
                    <li>
                      <a href="#" rel="">
                        Intellectual Property Claims
                      </a>
                    </li>
                    <li>
                      <a href="#">Investor Relations</a>
                    </li>
                  </ul>
                </div>
              </article>
            </div>
            <div className="item">
              <article className="article">
                <div className="title">
                  <h6>Support</h6>
                </div>
                <div className="content">
                  <ul>
                    <li>
                      <a href="#">Help &amp; Support</a>
                    </li>
                    <li>
                      <a href="#">Trust &amp; Safety</a>
                    </li>
                    <li>
                      <a href="#">Selling</a>
                    </li>
                    <li>
                      <a href="#">Buying </a>
                    </li>
                  </ul>
                </div>
              </article>
            </div>
            <div className="item">
              <article className="article">
                <div className="title">
                  <h6>Communlty</h6>
                </div>
                <div className="content">
                  <ul>
                    <li>
                      <a href="#">Events</a>
                    </li>
                    <li>
                      <a href="#">Blog</a>
                    </li>
                    <li>
                      <a href="#">Forum</a>
                    </li>
                    <li>
                      <a href="#">Community Standards</a>
                    </li>
                    <li>
                      <a href="#">Podcast</a>
                    </li>
                    <li>
                      <a href="#">Affiliates</a>
                    </li>
                    <li>
                      <a href="#">Invite a Friend</a>
                    </li>
                    <li>
                      <a href="#">Become a Seller</a>
                    </li>
                  </ul>
                </div>
              </article>
            </div>
            <div className="item">
              <article className="article">
                <div className="title">
                  <h6>More From</h6>
                </div>
                <div className="content">
                  <ul className="ul_5">
                    <li className="li_5">
                      <a href="#"> Business</a>
                    </li>
                    <li>
                      <a href="#"> Pro</a>
                    </li>
                    <li>
                      <a href="#"> Studios</a>
                    </li>
                    <li>
                      <a href="#"> Logo Maker</a>
                    </li>
                    <li>
                      <a href="#"> Guides</a>
                    </li>
                    <li>
                      <a href="#">Get Inspired</a>
                    </li>
                    <li>
                      <a href="#"> Select</a>
                    </li>
                    <li>
                      <a href="#">ClearVoice</a>
                      <p>Content Marketing</p>
                    </li>
                    <li>
                      <a href="#"> Workspace</a>
                      <p>Invoice Software</p>
                    </li>
                    <li>
                      <a href="#">Learn</a>
                      <p>Online Courses</p>
                    </li>
                    <li>
                      <a href="#">Working Not Working</a>
                    </li>
                  </ul>
                </div>
              </article>
            </div>
          </div>
          <div className="footer_bottom">
            <div className="left">
              <span className="logo_footer">
                <CustomLogoFooter />
              </span>
              <span className="copyright text-trunc">
                © International Ltd. 2022
              </span>
            </div>
            <div className="right">
              <ul className="social">
                <li>
                  <a href="#">
                    <span className="icon">
                      <i className="fa-brands fa-twitter" />
                    </span>
                  </a>
                </li>
                <li>
                  <a href="#">
                    <span className="icon">
                      <i className="fa-brands fa-facebook" />
                    </span>
                  </a>
                </li>
                <li>
                  <a href="#">
                    <span className="icon">
                      <i className="fa-brands fa-linkedin" />
                    </span>
                  </a>
                </li>
                <li>
                  <a href="#">
                    <span className="icon">
                      <i className="fa-brands fa-pinterest" />
                    </span>
                  </a>
                </li>
                <li>
                  <a href="#">
                    <span className="icon">
                      <i className="fa-brands fa-instagram" />
                    </span>
                  </a>
                </li>
              </ul>
              <section className="settings">
                <div className="settings_locale">
                  <button className="selection">
                    <span>
                      <i className="fa-solid fa-globe" />
                    </span>
                    <span>English</span>
                  </button>
                </div>
                <div className="settings_locale">
                  <button className="selection">
                    <span>US$ USD</span>
                  </button>
                </div>
                <button className="button">
                  <span>
                    <i className="fa-solid fa-person" />
                  </span>
                </button>
              </section>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
